// extracted by mini-css-extract-plugin
export var carrierIconPlaceholder = "_7g-1";
export var dragButton = "_7g-5";
export var sortableCell = "_7g-4";
export var sortableNameCell = "_7g-3";
export var sortableRow = "_7g-0";
export var tableHeader = "_7g-6";
export var tableHeaderWithCardHeader = "_7g-7";
export var weightInputRow = "_7g-2";